import axios from '../../shared/axios';

export function confirmInvitation(invitationId, data) {
    return axios.patch(
        Jobtoolz.api.url + '/content/v1/interviews/invitation/' + invitationId,
        data
    ).then(response => response.data);
}

export function rescheduleInterview(interviewInvitationId, data)
{
    return axios.patch(
        Jobtoolz.api.url + `/content/v1/interviews/${interviewInvitationId}/reschedule`,
        data
    ).then(response => response.data);
}

export function cancelInterview(interviewInvitationId, data)
{
    return axios.patch(
        Jobtoolz.api.url + `/content/v1/interviews/${interviewInvitationId}/cancel`,
        data
    ).then(response => response.data);
}
